import React from 'react';

import NumberFormat from 'react-number-format';
import { shape, func, string } from 'prop-types';

import RevenueThreshold from '../FeeStructure/RevenueThreshold';
import { combinedRevOptions } from '../../../../constants';
import { InputFormField } from '../../../../common';

export default function CombinedRevShare({
  formData,
  setFormData,
  selectedCurrency,
  setUpdatedFormData,
  updatedFormData,
  feeStructureErrors,
  setFeeStructureErrors,
  showFooter,
  sectionError,
  setSectionError,
  section,
}) {
  const vendorField = formData?.fee_structure_vendor_type;
  const sellerField = formData?.fee_structure_seller_type;
  const handleChange = (event, key, type) => {
    showFooter(true);
    if (key.includes('quarterly')) {
      let changedValue = {
        ...formData?.fee_structure?.[sellerField].quarterly_rev_share,
      };
      if (event?.value) {
        changedValue = {
          ...formData?.fee_structure?.[sellerField].quarterly_rev_share,
          [key]: event.value,
        };
      } else {
        delete formData?.fee_structure?.[sellerField].quarterly_rev_share?.[
          key
        ];
        changedValue = {
          ...formData?.fee_structure?.[sellerField].quarterly_rev_share,
        };
      }
      setFormData({
        ...formData,
        fee_structure: {
          ...formData?.fee_structure,
          [sellerField]: {
            ...formData?.fee_structure?.[sellerField],
            quarterly_rev_share: { ...changedValue },
          },
          [vendorField]: {
            ...formData?.fee_structure?.[vendorField],
            quarterly_rev_share: {
              ...changedValue,
            },
          },
        },
      });
      setUpdatedFormData({
        ...updatedFormData,
        fee_structure: {
          ...updatedFormData?.fee_structure,
          [sellerField]: {
            ...updatedFormData?.fee_structure?.[sellerField],
            quarterly_rev_share: {
              ...changedValue,
            },
          },
          [vendorField]: {
            ...updatedFormData?.fee_structure?.[vendorField],
            quarterly_rev_share: {
              ...changedValue,
            },
          },
        },
      });
    } else if (key.search(/\bmonth\b/) >= 0) {
      let changedValue = {
        ...formData?.fee_structure?.[sellerField].monthly_rev_share,
      };
      if (event?.value) {
        changedValue = {
          ...formData?.fee_structure?.[sellerField].monthly_rev_share,
          [key]: event.value,
        };
      } else {
        delete formData?.fee_structure?.[sellerField].monthly_rev_share?.[key];
        changedValue = {
          ...formData?.fee_structure?.[sellerField].monthly_rev_share,
        };
      }
      setFormData({
        ...formData,
        fee_structure: {
          ...formData?.fee_structure,
          [sellerField]: {
            ...formData?.fee_structure?.[sellerField],
            monthly_rev_share: {
              ...changedValue,
            },
          },
          [vendorField]: {
            ...formData?.fee_structure?.[vendorField],
            monthly_rev_share: {
              ...changedValue,
            },
          },
        },
      });
      setUpdatedFormData({
        ...updatedFormData,
        fee_structure: {
          ...updatedFormData?.fee_structure,
          [sellerField]: {
            ...updatedFormData?.fee_structure?.[sellerField],
            monthly_rev_share: {
              ...changedValue,
            },
          },
          [vendorField]: {
            ...updatedFormData?.fee_structure?.[vendorField],
            monthly_rev_share: {
              ...changedValue,
            },
          },
        },
      });
    } else {
      setFormData({
        ...formData,
        fee_structure: {
          ...formData?.fee_structure,
          [sellerField]: {
            ...formData?.fee_structure?.[sellerField],
            [key]:
              type === 'choices' || type === 'numberformat'
                ? event?.value
                  ? event?.value
                  : null
                : event?.target?.value
                ? event?.target?.value
                : null,
          },
          [vendorField]: {
            ...formData?.fee_structure?.[vendorField],
            [key]:
              type === 'choices' || type === 'numberformat'
                ? event?.value
                  ? event?.value
                  : null
                : event?.target?.value
                ? event?.target?.value
                : null,
          },
        },
      });

      setUpdatedFormData({
        ...updatedFormData,
        fee_structure: {
          ...updatedFormData?.fee_structure,
          [sellerField]: {
            ...updatedFormData?.fee_structure?.[sellerField],
            [key]:
              type === 'choices' || type === 'numberformat'
                ? event?.value
                  ? event?.value
                  : null
                : event?.target?.value
                ? event.target.value
                : null,
          },
          [vendorField]: {
            ...updatedFormData?.fee_structure?.[vendorField],
            [key]:
              type === 'choices' || type === 'numberformat'
                ? event?.value
                  ? event?.value
                  : null
                : event?.target?.value
                ? event.target.value
                : null,
          },
        },
      });
    }

    if (
      (key === 'threshold_type' &&
        (feeStructureErrors?.[sellerField]?.quarterly_rev_share ||
          feeStructureErrors?.[sellerField]?.monthly_rev_share ||
          feeStructureErrors?.[sellerField]?.sales_threshold)) ||
      (formData?.fee_structure?.[sellerField]?.quarterly_rev_share &&
        Object.keys(formData?.fee_structure?.[sellerField]?.quarterly_rev_share)
          .length === 3 &&
        event.value &&
        feeStructureErrors?.[sellerField]?.quarterly_rev_share) ||
      (formData?.fee_structure?.[sellerField]?.monthly_rev_share &&
        Object.keys(formData?.fee_structure?.[sellerField]?.monthly_rev_share)
          .length === 11 &&
        event.value &&
        feeStructureErrors?.[sellerField]?.monthly_rev_share) ||
      (feeStructureErrors?.[sellerField]?.sales_threshold &&
        (formData?.fee_structure?.[sellerField]?.sales_threshold ||
          event.value))
    ) {
      if (
        formData &&
        formData?.fee_structure?.[vendorField]?.vendor_same_as_seller &&
        formData?.seller_type?.value === 'Hybrid'
      ) {
        setSectionError({
          ...sectionError,
          [sellerField]: {
            feeType: sectionError?.[sellerField]?.feeType
              ? sectionError?.[sellerField]?.feeType - 1
              : 0,
          },
          [vendorField]: {
            feeType: !(
              formData &&
              formData?.fee_structure?.[vendorField]?.vendor_billing_report
            )
              ? sectionError?.[sellerField]?.feeType - 1 + 1
              : sectionError?.[sellerField]?.feeType - 1,
          },
        });

        setFeeStructureErrors((prevState) => ({
          ...prevState,
          [sellerField]: {
            ...feeStructureErrors?.[sellerField],
            quarterly_rev_share: '',
            billing_cap: '',
            monthly_rev_share: '',
            sales_threshold: '',
          },
          [vendorField]: {
            ...feeStructureErrors?.[vendorField],
            quarterly_rev_share: '',
            billing_cap: '',
            monthly_rev_share: '',
            sales_threshold: '',
          },
        }));
      } else {
        setSectionError({
          ...sectionError,
          [sellerField]: { feeType: sectionError?.[sellerField]?.feeType - 1 },
        });

        setFeeStructureErrors((prevState) => ({
          ...prevState,
          [sellerField]: {
            ...feeStructureErrors?.[sellerField],
            quarterly_rev_share: '',
            billing_cap: '',
            monthly_rev_share: '',
            sales_threshold: '',
          },
        }));
      }
    }
  };

  const checkAllFieldsOFRetainerPresent = (item) => {
    if (
      (formData?.fee_structure?.[section]?.retainer_type === 'Fixed' ||
        !formData?.fee_structure?.[section]?.retainer_type) &&
      formData?.fee_structure?.[section]?.monthly_retainer
    ) {
      return true;
    }

    if (
      formData?.fee_structure?.[section]?.retainer_type === 'quarterly' &&
      formData?.fee_structure?.[section]?.quarterly_monthly_retainer?.[
        item?.key
      ]
    ) {
      return true;
    }

    if (
      formData?.fee_structure?.[section]?.retainer_type === 'monthly' &&
      formData?.fee_structure?.[section]?.monthly_monthly_retainer?.[item?.key]
    ) {
      return true;
    }

    return false;
  };

  const generateHTML = (item) => {
    if (item?.type?.includes('number')) {
      return (
        <>
          <NumberFormat
            className={
              (item?.fieldOf !== 'retainer' &&
                !(formData && formData?.fee_structure?.[section]?.[item.key]) &&
                item.isMandatory) ||
              (item?.fieldOf === 'retainer' &&
                !checkAllFieldsOFRetainerPresent(item)) ||
              (feeStructureErrors?.[section]?.quarterly_rev_share &&
                !formData?.fee_structure?.[section]?.quarterly_rev_share?.[
                  item.key
                ] &&
                item.fieldOf === 'threshold') ||
              (feeStructureErrors?.[section]?.monthly_rev_share &&
                !formData?.fee_structure?.[section]?.monthly_rev_share?.[
                  item.key
                ] &&
                item.fieldOf === 'threshold') ||
              (feeStructureErrors?.[section]?.sales_threshold &&
                !formData?.fee_structure?.[section]?.sales_threshold &&
                item.fieldOf === 'threshold') ||
              (feeStructureErrors?.[section]?.quarterly_monthly_retainer &&
                !formData?.fee_structure?.[section]
                  ?.quarterly_monthly_retainer?.[item.key] &&
                item.fieldOf === 'retainer') ||
              (feeStructureErrors?.[section]?.monthly_monthly_retainer &&
                !formData?.fee_structure?.[section]?.monthly_monthly_retainer?.[
                  item.key
                ] &&
                item.fieldOf === 'retainer') ||
              (feeStructureErrors?.[section]?.monthly_retainer &&
                !formData?.fee_structure?.[section]?.monthly_retainer &&
                item.fieldOf === 'retainer') ||
              (item.key === 'billing_cap' &&
                feeStructureErrors?.[section]?.billing_cap) ||
              (item.key === 'billing_minimum' &&
                feeStructureErrors?.[section]?.billing_minimum)
                ? 'form-control  form-control-error'
                : 'form-control '
            }
            name={item.key}
            id={item.key}
            value={
              item.key.includes('quarterly')
                ? formData?.fee_structure?.[sellerField]?.[
                    item.fieldOf === 'retainer'
                      ? 'quarterly_monthly_retainer'
                      : 'quarterly_rev_share'
                  ]?.[item.key]
                : item.key.search(/\bmonth\b/) >= 0
                ? formData.fee_structure?.[sellerField]?.[
                    item.fieldOf === 'retainer'
                      ? 'monthly_monthly_retainer'
                      : 'monthly_rev_share'
                  ]?.[item.key]
                : formData?.fee_structure?.[sellerField]?.[item.key]
            }
            placeholder={item.placeholder || item.label}
            suffix={item.type === 'number-percent' ? '%' : ''}
            onValueChange={(event) =>
              handleChange(event, item.key, 'numberformat', item.fieldOf)
            }
            thousandSeparator
            decimalScale={2}
            isAllowed={(values) => {
              const { formattedValue, floatValue } = values;
              if (floatValue == null) {
                return formattedValue === '';
              }
              if (item.key === 'rev_share') {
                return floatValue >= 0 && floatValue <= 10;
              }
              return floatValue <= 100000000;
            }}
            allowNegative={false}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {' '}
      <div className=" liner-titles spacing mt-3 mb-3">Combined Rev Share</div>
      <p>
        By summing the sales of the
        {sellerField} and {vendorField} accounts and applying the rev share
        percentage on the amount above the combined threshold, BBE&apos;s rev
        share is evaluated.
      </p>
      {combinedRevOptions.map((field) => (
        <InputFormField className="mt-3" key={field.key}>
          <label htmlFor={field.key}>{field.label}</label>

          {field.type === 'threshold' ? (
            <RevenueThreshold
              formData={formData}
              handleChange={handleChange}
              generateHTML={generateHTML}
              setFormData={setFormData}
              feeStructureErrors={feeStructureErrors}
              selectedCurrency={selectedCurrency}
              section={section}
            />
          ) : (
            <>
              <div className="input-container">
                {generateHTML(field)}
                {field.suffix ? (
                  <span className="input-icon end">{field.suffix} </span>
                ) : (
                  ''
                )}
              </div>
              <p style={{ color: '#556178' }} className="mt-1 mb-0">
                {field.subtitle}
              </p>
            </>
          )}
        </InputFormField>
      ))}
    </>
  );
}

CombinedRevShare.defaultProps = {
  setUpdatedFormData: () => {},
  setFormData: () => {},
  formData: {},
  updatedFormData: {},
  showFooter: () => {},
  setSectionError: () => {},
  sectionError: {},
  feeStructureErrors: {},
  setFeeStructureErrors: () => {},
  selectedCurrency: '$ (USD)',
  section: '',
};

CombinedRevShare.propTypes = {
  formData: shape({
    fee_structure: shape({}),
  }),
  setUpdatedFormData: func,
  setFormData: func,
  updatedFormData: shape({}),
  showFooter: func,
  setSectionError: func,
  sectionError: shape({}),
  feeStructureErrors: shape({}),
  setFeeStructureErrors: func,
  selectedCurrency: string,
  section: string,
};
